/**
 * Validates an Israeli ID number
 * @param {string} id - The ID number to validate
 * @returns {boolean} - True if the ID is valid, false otherwise
 */
export const is_israeli_id_number = (id) => {
	id = String(id).trim();
	if (id.length > 9 || isNaN(id)) return false;
	id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
	return Array.from(id, Number).reduce((counter, digit, i) => {
		const step = digit * ((i % 2) + 1);
		return counter + (step > 9 ? step - 9 : step);
	}, 0) % 10 === 0;
}

export const isIsraeliIDNumber = (id) => {
    // Convert input to string and trim whitespace
    id = String(id).trim();

    // Check if input is 5 to 9 digits long and contains only digits
    if (!/^\d{5,9}$/.test(id)) return false;

    // Reject IDs with all identical digits (e.g. 000000000, 111111111)
    if (/^(\d)\1{4,8}$/.test(id)) return false;

    // Pad the ID with leading zeros to make it exactly 9 digits
    id = id.padStart(9, '0');

    // Calculate checksum using the Luhn algorithm
    const sum = id.split('').reduce((acc, digit, i) => {
        let num = Number(digit) * ((i % 2) + 1); // Multiply by 1 or 2 alternately
        if (num > 9) num -= 9;                  // Subtract 9 if result is more than 9
        return acc + num;
    }, 0);

    // Valid ID if checksum is divisible by 10
    return sum % 10 === 0;
}
